export default __webpack_public_path__ + "static/media/mat1.f0468e80.png";